export default [
  'components-balance-card-title',
  'components-balance-card-number',
  'components-balance-card-sign',
]
